import type { Security } from '@ipfabric/utils';
import type { TestReferenceKey } from 'components/SecuritySchema/model/ResolvedReferencedTest';

export const getTestReferenceKey = (
  reference: Security.TestReference,
): TestReferenceKey => `${reference.dictionary}/${reference.key}`;
